// extracted by mini-css-extract-plugin
export default {"container":"Dropdown_container__3Lnz2","menu":"Dropdown_menu__SXyz+","spacer":"Dropdown_spacer__ITm9t","hover":"Dropdown_hover__cN4KQ"};